var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"tips-card"},[_c('div',[_c('p'),_c('p',{staticClass:"tip-div"},[_vm._v("重要提示： ")]),_c('p',{staticClass:"tip-div"},[_vm._v("1、应用场景：快件出港需先进行粗分后，再上交叉带供件台进行细分操作；")]),_c('p',{staticClass:"tip-div"},[_vm._v("2、需先配置好粗分方案，系统按照粗分方案进行分拣")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }